<div class="flex items-baseline gap-1 mb-2 min-w-0">
  <span class="text-sm font-semibold text-gray-900 truncate min-w-0">
    {{ data().label }}
  </span>
  @if (data().version) {
    <span class="shrink-0 bg-gray-200 text-gray-700 text-xs px-1.5 py-0.5 rounded-full font-medium">
      v{{ data().version }}
    </span>
  }
  @if (data().kind; as kind) {
    <span class="shrink-0 bg-gray-200 text-gray-700 text-xs px-1.5 py-0.5 rounded-full font-medium">
      {{ kind === 'interaction' ? 'Interactie' : 'Template' }}
    </span>
  }
  @if (data().status; as status) {
    <span
      class="shrink-0 text-xs px-1.5 py-0.5 rounded-full font-medium"
      [ngClass]="{
        'bg-gray-200 text-gray-700': status === 'draft',
        'bg-secondary-200 text-secondary-950': status === 'published',
      }"
    >
      {{ status | mapFrom: statusMapping }}
    </span>
  }
</div>
<div class="border-t border-gray-300 w-full"></div>
